'use client'

import { Configure, usePagination } from 'react-instantsearch'
import { Separator } from 'primitives/separator'
import { useCategories } from 'algolia/algolia.components'
import { VirtualSearchBox } from './virtual-search-box'
import { SearchResults } from './search-results'
import { SearchPagination } from './search-pagination'

export interface SearchResultsContainerProps {
  filters?: string
  hidePagination?: boolean
  isGalleryPage?: boolean
  noResultsText: string
  nextText: string
  previousText: string
}

export function SearchResultsContainer({
  filters,
  hidePagination = false,
  isGalleryPage = false,
  nextText,
  previousText,
  noResultsText,
}: SearchResultsContainerProps) {
  const { subcategory } = useCategories()
  const { currentRefinement, nbPages, refine } = usePagination()

  return (
    <div className="flex w-full flex-col gap-8">
      <Configure
        hitsPerPage={isGalleryPage ? 100 : 20}
        filters={filters || `${isGalleryPage && subcategory ? `subcategory:"${subcategory}"` : ''}`}
        attributesToRetrieve={[
          'imageUrl',
          'width',
          'height',
          'subject',
          'objectID',
          'title',
          'tags',
          'category',
          'subcategory',
          'userId',
        ]}
        attributesToHighlight={[]}
      />
      <VirtualSearchBox />
      <SearchResults noResultsText={noResultsText} />
      {hidePagination ? null : (
        <>
          <Separator />
          <SearchPagination
            currPage={currentRefinement + 1}
            totalPages={nbPages}
            onChangePage={page => refine(page - 1)}
            nextText={nextText}
            previousText={previousText}
          />
        </>
      )}
    </div>
  )
}
